<template>
  <v-dialog
    v-model="visible"
    width="550"
    :close-on-content-click="false"
    :activator="selectedElement"
    :nudge-bottom="4"
    offset-y
    :fullscreen="$vuetify.breakpoint.smAndDown"
    scrollable
    content-class="elevation-0"
  >
    <v-card class="rounded-xl">
      <template v-if="selectedEvent">
        <v-img :src="selectedEventImage" :height="$vuetify.breakpoint.smAndDown ? '0px' : '220px'">
          <v-card-title class="pt-3 px-5 ma-0 pa-0 justify-end">
            <span>
              <v-btn
                class="hidden-xs-only"
                v-if="allowEdit(selectedEvent)"
                icon
                style="background-color: rgb(255, 255, 255, 0.7)"
                @click="downloadAnmeldungen()"
                ><v-icon class="black--text">print</v-icon></v-btn
              >
              <v-btn icon style="background-color: rgb(255, 255, 255, 0.7)" @click="shareVeranstaltung(selectedEvent)"
                ><v-icon class="black--text">ios_share</v-icon></v-btn
              >
              <v-btn
                v-if="allowEdit(selectedEvent)"
                icon
                style="background-color: rgb(255, 255, 255, 0.7)"
                @click="showVeranstaltungEdit = true"
                ><v-icon class="black--text">edit</v-icon></v-btn
              >
              <v-btn class="hidden-xs-only" icon style="background-color: rgb(255, 255, 255, 0.7)" @click="close()"
                ><v-icon class="black--text">close</v-icon></v-btn
              >
            </span>
          </v-card-title>
        </v-img>
        <v-card-title style="background-color: rgb(255, 255, 255, 0.3)" class="pl-6 pb-0 pt-4 ma-0 pa-0">
          <span class="body-2"
            >{{ $filters.date(selectedEvent.vonDatum, "DD.MM.YYYY") }}, {{ selectedEvent.vonZeit }} Uhr -
            {{ selectedEvent.bisZeit }} Uhr</span
          >
        </v-card-title>
        <v-card-title class="pt-0">
          <span style="word-break: break-word" class="font-weight-bold black--text">{{ selectedEvent.name }}</span>
        </v-card-title>
        <v-card-text class="ma-0 pa-0">
          <v-row class="pa-0 ma-0" no-gutters>
            <v-col cols="12" class="pa-0 ma-0" v-if="selectedEvent.bemerkung">
              <v-list-item dense>
                <v-list-item-avatar class="pa-0 ma-0">
                  <v-icon>info</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  {{ selectedEvent.bemerkung }}
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" class="pa-0 ma-0" v-if="selectedEvent.ort">
              <v-list-item dense>
                <v-list-item-avatar class="pa-0 ma-0">
                  <v-icon>location_on</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  {{ selectedEvent.ort }}
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" class="pa-0 ma-0" v-if="selectedEvent.anmeldungBis">
              <v-list-item dense>
                <v-list-item-avatar class="pa-0 ma-0">
                  <v-icon>event</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="font-weight-regular caption">Anmeldung bis</v-list-item-subtitle>
                  {{ $filters.date(selectedEvent.anmeldungBis, "DD.MM.YYYY") }}
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" class="pa-0 ma-0" v-if="selectedEvent.kleiderordnung">
              <v-list-item dense>
                <v-list-item-avatar class="pa-0 ma-0">
                  <v-icon>face</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  {{ selectedEvent.kleiderordnung }}
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" class="pa-0 ma-0" v-if="selectedEvent.kategorie">
              <v-list-item dense>
                <v-list-item-avatar class="pa-0 ma-0">
                  <v-icon>label</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  {{ selectedEvent.kategorie }}
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" class="pa-0 ma-0" v-if="selectedEvent.preis">
              <v-list-item dense>
                <v-list-item-avatar class="pa-0 ma-0">
                  <v-icon>euro</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  {{ selectedEvent.preis | money }}
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <template v-if="selectedEvent.anmeldungen">
            <v-expansion-panels flat style="width: 99%">
              <v-expansion-panel class="pa-0 ma-0">
                <v-expansion-panel-header class="pa-0 ma-0">
                  <v-list-item dense>
                    <v-list-item-avatar class="pa-n2 ma-0">
                      <v-icon>group</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="mr-n4">
                      <span v-if="selectedEvent.anmeldungen.length + selectedEvent.weitereAnmeldungen.length === 1"
                        >1 Anmeldung</span
                      >
                      <span v-else
                        >{{
                          selectedEvent.anmeldungen.length + selectedEvent.weitereAnmeldungen.length
                        }}
                        Anmeldungen</span
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-simple-table fixed-header max-height="calc(100vh - 415px)" dense>
                    <tbody>
                      <tr v-for="item in anmeldungen" :key="item.id">
                        <td>{{ item.bbr }}</td>
                      </tr>
                      <tr
                        v-if="selectedEvent.weitereAnmeldungen.length > 0"
                        @click="showAlleAnmeldungen = !showAlleAnmeldungen"
                      >
                        <td v-if="!showAlleAnmeldungen">
                          + {{ selectedEvent.weitereAnmeldungen.length }} Begleitungen
                          <v-icon>keyboard_arrow_down</v-icon>
                        </td>
                        <td v-if="showAlleAnmeldungen"><v-icon>keyboard_arrow_up</v-icon> Begleitungen ausblenden</td>
                      </tr>
                      <tr v-if="showAlleAnmeldungen" v-for="item in selectedEvent.weitereAnmeldungen" :key="item.id">
                        <td>{{ item.name }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="mb-6 mb-md-0">
          <v-btn rounded text @click="close()">Schließen</v-btn>
          <v-spacer></v-spacer>
          <div v-if="selectedEvent.anmeldungBis >= heute || !selectedEvent.anmeldungBis">
            <template v-if="selectedEvent.anmeldungen">
              <v-btn
                rounded
                text
                v-if="
                  selectedEvent.anmeldungen.includes(currentBbr) &&
                  !selectedEvent.pflichtanmeldungen.includes(currentBbrStatus)
                "
                color="accent"
                @click="showZuVeranstaltungAbmelden = true"
                >Abmelden</v-btn
              >
              <v-btn
                icon
                v-if="selectedEvent.anmeldungen.includes(currentBbr)"
                color="primary"
                @click="showWeiterenAnmelden = true"
                ><v-icon>exposure_plus_1</v-icon></v-btn
              >
              <v-btn
                rounded
                text
                v-if="!selectedEvent.anmeldungen.includes(currentBbr)"
                color="primary"
                @click="zuVeranstaltungAnmelden()"
                >Anmelden</v-btn
              >
            </template>
            <br />
            <div v-if="selectedEvent.pflichtanmeldungen">
              <span
                v-if="
                  selectedEvent.anmeldungen.includes(currentBbr) &&
                  selectedEvent.pflichtanmeldungen.includes(currentBbrStatus)
                "
              >
                Du bist Pflichtangemeldet und kannst dich nicht über das System abmelden. Bitte melde dich diekt beim
                Consenior ab. Dieser trägt das dann im System ein.
              </span>
            </div>
          </div>
          <v-card-text v-else>
            Eine An- oder Abmeldung zu dieser Veranstaltung ist nicht mehr möglich. Bitte wende Dich direkt an den
            Consenior, falls du dich nachträglich an- bzw abmelden willst.
          </v-card-text>
        </v-card-actions>
      </template>
    </v-card>

    <v-dialog
      v-model="showWeiterenAnmelden"
      width="500"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card class="rounded-lg">
        <v-card-title> Weitere Personen anmelden </v-card-title>
        <v-card-subtitle class="pt-1">
          Hier kannst du weitere Personen, Freunde und Bekannte, die sich nicht selber anmelden können, anmelden.
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <v-list dense>
            <v-list-item
              v-if="item.angemeldetVon === currentBbr"
              v-for="item in selectedEvent.weitereAnmeldungen"
              :key="item.id"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon @click="weiterenAbmelden(item)">close</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <v-text-field
            outlined
            dense
            hide-details
            v-model="name"
            placeholder="Bitte Vorname und Nachname eintragen."
            append-outer-icon="add"
            @click:append-outer="weiterenAnmelden()"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mb-6 mb-md-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showWeiterenAnmelden = false"> Schließen </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialogDelete
      :visible.sync="showZuVeranstaltungAbmelden"
      title="Abmelden"
      :message="'Willst du dich wirklich von der Veranstaltung ' + selectedEvent.name + ' abmelden?'"
      abbrechen="Angemeldet bleiben"
      weiter="Abmelden"
      @closeTrue="zuVeranstaltungAbmelden()"
      @closeFalse="showZuVeranstaltungAbmelden = false"
    >
    </dialogDelete>
    <dialogVeranstaltungEdit
      :visible.sync="showVeranstaltungEdit"
      :veranstaltung="selectedEvent"
      @close="showVeranstaltungEdit = false"
    ></dialogVeranstaltungEdit>
  </v-dialog>
</template>

<script>
  import JSPDF from "jspdf";
  export default {
    props: ["selectedEvent", "visible"],
    data() {
      return {
        loading: "",
        showVeranstaltungEdit: false,
        showWeiterenAnmelden: false,
        showZuVeranstaltungAbmelden: false,
        showEvent: false,
        name: "",
        selectedElement: null,
        showAlleAnmeldungen: false,
        heute: new Date().toISOString().substr(0, 10),
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      selectedEventImage() {
        let link = "/static/calendarEventImages/img_beer_1x.jpg";
        if (this.selectedEvent.titel && this.$vars.verbindung === "rbo") {
          const array = [
            { name: "ausklang", bild: "bbq" },
            { name: "bowling", bild: "bowling" },
            { name: "brunch", bild: "breakfast" },
            { name: "billard", bild: "billard" },
            { name: "bummel", bild: "beer" },
            { name: "cc", bild: "convent" },
            { name: "cocktail", bild: "drinks" },
            { name: "convent", bild: "convent" },
            { name: "dc", bild: "convent" },
            { name: "dinner", bild: "dinner" },
            { name: "essen", bild: "dinner" },
            { name: "examen", bild: "graduation" },
            { name: "fahne", bild: "fahnenhissung" },
            { name: "flunkyball", bild: "beer" },
            { name: "film", bild: "cinema" },
            { name: "frühstück", bild: "breakfast" },
            { name: "fußball", bild: "soccer" },
            { name: "golf", bild: "golf" },
            { name: "gottesdienst", bild: "learninstrument" },
            { name: "grill", bild: "bbq" },
            { name: "halloween", bild: "halloween" },
            { name: "hochamt", bild: "learninstrument" },
            { name: "kaffee", bild: "coffee" },
            { name: "kegeln", bild: "bowling" },
            { name: "kneipe", bild: "kneipe" },
            { name: "kommers", bild: "kneipe" },
            { name: "messe", bild: "learninstrument" },
            { name: "oc", bild: "convent" },
            { name: "party", bild: "party" },
            { name: "poker", bild: "drinks" },
            { name: "pool", bild: "swimming" },
            { name: "salon", bild: "drinks" },
            { name: "schwimm", bild: "swimming" },
            { name: "segel", bild: "sailing" },
            { name: "sing", bild: "learninstrument" },
            { name: "sport", bild: "walk" },
            { name: "stiftungsfest", bild: "kneipe" },
            { name: "tag des ripuarenhauses", bild: "clean" },
            { name: "tanz in den mai", bild: "party" },
            { name: "tanz", bild: "dancing" },
            { name: "vortrag", bild: "graduation" },
            { name: "wander", bild: "hiking" },
            { name: "wc", bild: "convent" },
            { name: "weihnacht", bild: "xmas" },
            { name: "weihnachtsparty", bild: "xmasparty" },
          ];
          const substring = this.selectedEvent.titel;
          const match = array.find((element) => {
            if (substring.toLowerCase().includes(element.name.toLowerCase())) {
              return true;
            }
          });
          if (match !== undefined) {
            link = "/static/calendarEventImages/img_" + match.bild + "_1x.jpg";
          }
        }
        return link;
      },
      anmeldungen() {
        let anmeldungen = this.selectedEvent.anmeldungen
          .map((item) => {
            let bbr = this.$store.getters["bbrbbr/bbr"](item);
            return {
              id: item,
              bbr: `${bbr.nachname}, ${bbr.vorname}`,
            };
          })
          .sort((a, b) => {
            if (a.bbr < b.bbr) {
              return -1;
            }
            if (a.bbr > b.bbr) {
              return 1;
            }
            return 0;
          });
        return anmeldungen;
      },
      currentBbrStatus() {
        return this.$store.getters["bbrbbr/bbr"](this.currentBbr).status;
      },
    },
    methods: {
      allowEdit(event) {
        let seiten = this.$store.getters["einstellungen/einstellung"]("rollen");
        let bbr = this.$store.state.bbrbbr.bbrbbr.find((d) => d.anmeldeID === this.$firebase.auth().currentUser.uid);
        let variable = false;
        if (seiten !== undefined) {
          seiten.seiten.forEach((item) => {
            let modul = item.module.find((a) => a.value === "veranstaltungen");
            if (modul) {
              let kalender = modul.props.find((a) => a.name === "Kalender");
              if (kalender) {
                if (kalender.wert.indexOf(event.kalender) > -1) {
                  if (item.berechtigt.indexOf(bbr.id) >= 0) {
                    variable = true;
                  }
                }
              }
            }
          });
        }
        if (bbr.id === "PBChUyAy7HWowQR4HlP3") {
          return true;
        } else {
          return variable;
        }
      },
      zuVeranstaltungAnmelden() {
        this.selectedEvent.anmeldungen.push(this.currentBbr);
        this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
        this.$firebase.analytics().logEvent("zuVeranstaltungAnmelden", {
          currentBbr: this.currentBbr,
          name: this.currentBbr,
        });
      },
      zuVeranstaltungAbmelden() {
        this.selectedEvent.anmeldungen.splice(this.selectedEvent.anmeldungen.indexOf(this.currentBbr), 1);
        this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
        this.$firebase.analytics().logEvent("zuVeranstaltungAbmelden", {
          currentBbr: this.currentBbr,
          name: this.currentBbr,
        });
        this.showZuVeranstaltungAbmelden = false;
      },
      weiterenAnmelden() {
        if (!this.selectedEvent.weitereAnmeldungen) {
          this.selectedEvent.weitereAnmeldungen = [];
        }
        this.selectedEvent.weitereAnmeldungen.push({
          angemeldetVon: this.currentBbr,
          name: this.name,
        });
        this.name = "";
        this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
      },
      weiterenAbmelden(item) {
        this.selectedEvent.weitereAnmeldungen.splice(this.selectedEvent.weitereAnmeldungen.indexOf(item), 1);
        this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
      },
      async shareVeranstaltung(event) {
        try {
          await navigator.clipboard.writeText("https://rbo.korpodesk.de/event/" + event.id);
          this.$store.state.snackbar = {
            show: true,
            nachricht: "Link zur Veranstaltung kopiert.",
          };
        } catch ($e) {
          this.$store.state.snackbar = {
            show: true,
            nachricht: "Fehler bei der Linkerstellung.",
          };
        }
      },
      downloadAnmeldungen() {
        let veranstaltung = this.selectedEvent;
        let anmeldungen = [];
        veranstaltung.anmeldungen.forEach((item) => {
          const bbr = this.$store.getters["bbrbbr/bbr"](item);
          anmeldungen.push({
            id: item,
            name: bbr.nachname + ", " + bbr.vorname,
            weitere: veranstaltung.weitereAnmeldungen
              .filter((weitereAnmeldung) => weitereAnmeldung.angemeldetVon === item)
              .map((weitereAnmeldung) => weitereAnmeldung.name),
          });
        });
        anmeldungen.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        console.log(veranstaltung);
        let doc = new JSPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
        });
        doc.setFont("Times");
        doc.setFillColor(39, 84, 165);
        doc.rect(0, 90, 210, 1, "F");
        doc.setFillColor(219, 31, 41);
        doc.rect(0, 92, 210, 1, "F");
        let img = new Image();
        img.src = "/static/wappen.png";
        doc.addImage(img, 125, 30, 75, 75);
        doc.setFontSize(9);
        doc.text("K.D.St.V. Ripuaria Bonn | Meckenheimer Allee 146 | 53115 Bonn", 25, 87);
        doc.setFontSize(14);
        doc.setFont("Times", "bold");
        let formattedDate = new Date(veranstaltung.vonDatum).toLocaleString("de-DE", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        doc.text(
          "Anmeldungen " + veranstaltung.titel + " am " + formattedDate + " um " + veranstaltung.vonZeit + " Uhr",
          25,
          115,
          null,
          null,
          "left"
        );
        doc.setFont("Times", "normal");
        doc.setFontSize(11);
        formattedDate = new Date().toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
        let formattedTime = new Date().toLocaleString("de-DE", { hour: "2-digit", minute: "2-digit" });
        doc.text("Stand: " + formattedDate + ", " + formattedTime + " Uhr", 25, 121, null, null, "left");
        let seite = 1;
        let counter = 1;
        let zeile = 135;
        doc.setFillColor(0, 0, 0);
        doc.line(22, zeile - 6, 188, zeile - 6);
        for (var i = 0; i < anmeldungen.length; i++) {
          if (zeile > 270) {
            zeile = 25;
            doc.text(String(seite), 25, 280, null, null, "left");
            seite += 1;
            doc.addPage();
            doc.line(22, zeile - 6, 188, zeile - 6);
          }
          doc.text(25, zeile, String(counter));
          doc.text(35, zeile, anmeldungen[i].name);
          counter += 1;
          zeile += 6;
          let zeile2 = zeile;
          for (var j = 0; j < anmeldungen[i].weitere.length; j++) {
            if (zeile > 270) {
              zeile = 25;
              doc.text(String(seite), 25, 280, null, null, "left");
              seite += 1;
              doc.addPage();
              doc.line(22, zeile - 6, 188, zeile - 6);
            }
            doc.text(25, zeile, String(counter));
            doc.text(40, zeile, anmeldungen[i].weitere[j]);
            counter += 1;
            zeile += 6;
          }
          doc.line(22, zeile2 - 12, 22, zeile - 3);
          doc.line(178, zeile2 - 12, 178, zeile - 3);
          doc.line(188, zeile2 - 12, 188, zeile - 3);
          doc.line(22, zeile - 3, 188, zeile - 3);
          zeile += 3;
        }
        doc.save("Anmeldungen-" + veranstaltung.titel + ".pdf");
      },
      close() {
        this.$emit("close", false);
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// dialogVeranstaltung.vue?3de3ba9e